export default function genererCalculAutoTlpeSemaine() {
  return {
    produitId: null,
    anneeSemaine: 0,
    produitsFacesSelectionnes: [],
    quantiteSouhaitee: 0,
  };
}
